import $ from 'jquery';
import { Control } from './Control';


$(() => {   
    new Control();
});
